// extracted by mini-css-extract-plugin
export var button = "_bp-4";
export var hasDarkBackground = "_bp-7";
export var hasLightBackground = "_bp-6";
export var iconWrapper = "_bp-0";
export var large = "_bp-2";
export var medium = "_bp-1";
export var small = "_bp-5";
export var xsmall = "_bp-3";